/**
 * VictoryStore Design Fee Manager v4.1
 * Instant fee addition on add-to-cart
 * @version 4.1
 */

(function() {
  'use strict';
  
  const CONFIG = {
    DESIGN_FEE_VARIANT_ID: '45920982007948',
    TRIGGER_OPTION_NAME: 'Artwork Options',
    TRIGGER_OPTION_VALUE: 'Design It For Me',
  };

  if (window.designFeeManagerLoaded) return;
  window.designFeeManagerLoaded = true;

  console.log('✓ Design Fee Manager v4.1 (instant add)');

  // ===== INSTANT ADD ON PRODUCT PAGE =====
  function interceptAddToCart() {
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      
      // Only intercept product add-to-cart forms
      if (!form.getAttribute('action')?.includes('/cart/add')) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      const formData = new FormData(form);
      const selectedVariant = formData.get('id');
      
      // Check if "Design It For Me" is selected
      const artworkOption = Array.from(form.querySelectorAll('input[type="radio"]'))
        .find(input => input.checked && input.value === CONFIG.TRIGGER_OPTION_VALUE);
      
      if (artworkOption) {
        console.log('✅ Design option selected - adding product + fee together');
        
        // Add product first
        const productResponse = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (productResponse.ok) {
          const productData = await productResponse.json();
          
          // Immediately add fee linked to this product
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: CONFIG.DESIGN_FEE_VARIANT_ID,
              quantity: 1,
              properties: {
                _linked_to: productData.key,
                _is_design_fee: 'true',
                'For Product': productData.product_title
              }
            })
          });
          
          console.log('✅ Fee added instantly');
          
          // Redirect to cart or open cart drawer
          if (window.location.pathname.includes('/products/')) {
            window.location.href = '/cart';
          } else {
            // Trigger cart update event for drawer
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        }
      } else {
        // No design option - just add product normally
        await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (window.location.pathname.includes('/products/')) {
          window.location.href = '/cart';
        } else {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      }
    });
  }

  // ===== CART PAGE CLEANUP (still needed for orphaned fees) =====
  function checkCartOnLoad() {
    if (!window.location.pathname.includes('/cart')) return;
    
    setTimeout(async () => {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        
        const productsNeedingFees = cart.items.filter(item => 
          needsDesignFee(item) && !isDesignFee(item)
        );
        
        const existingFees = cart.items.filter(item => isDesignFee(item));
        const validKeys = productsNeedingFees.map(p => p.key);
        
        let changed = false;

        // Fix fee quantities
        for (const fee of existingFees) {
          if (fee.quantity !== 1) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: fee.key, quantity: 1 })
            });
            changed = true;
          }
        }

        // Remove orphaned fees
        for (const fee of existingFees) {
          const linkedKey = fee.properties?._linked_to;
          if (linkedKey && !validKeys.includes(linkedKey)) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: fee.key, quantity: 0 })
            });
            changed = true;
          }
        }
        
        // Remove duplicates
        const seenLinks = new Set();
        for (const fee of existingFees) {
          const linkedKey = fee.properties?._linked_to;
          if (linkedKey) {
            if (seenLinks.has(linkedKey)) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: fee.key, quantity: 0 })
              });
              changed = true;
            } else {
              seenLinks.add(linkedKey);
            }
          }
        }

        // Add missing fees (backup in case instant add failed)
        for (const product of productsNeedingFees) {
          const hasFee = existingFees.some(f => f.properties?._linked_to === product.key);
          if (!hasFee) {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: CONFIG.DESIGN_FEE_VARIANT_ID,
                quantity: 1,
                properties: {
                  _linked_to: product.key,
                  _is_design_fee: 'true',
                  'For Product': product.product_title
                }
              })
            });
            changed = true;
          }
        }

        if (changed) {
          setTimeout(() => window.location.reload(), 300);
        }
      } catch (error) {
        console.error('Cart check failed:', error);
      }
    }, 1000);
  }

  function needsDesignFee(item) {
    if (item.options_with_values) {
      return item.options_with_values.some(opt => 
        opt.name === CONFIG.TRIGGER_OPTION_NAME && 
        opt.value === CONFIG.TRIGGER_OPTION_VALUE
      );
    }
    return false;
  }

  function isDesignFee(item) {
    return item.variant_id?.toString() === CONFIG.DESIGN_FEE_VARIANT_ID ||
           item.properties?._is_design_fee === 'true';
  }

  // Initialize
  interceptAddToCart();
  checkCartOnLoad();
})();
